import { render } from "./GrowthChart.vue?vue&type=template&id=705c16ed&scoped=true"
import script from "./GrowthChart.vue?vue&type=script&lang=js"
export * from "./GrowthChart.vue?vue&type=script&lang=js"

import "./GrowthChart.vue?vue&type=style&index=0&id=705c16ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705c16ed"]])

export default __exports__